export default {
    home: 'Home',
    admin: 'Admin',
    adminLogin: 'Login',
    notFound: 'Page not found',
    noPower: 'No access permission',
    noTitle: 'No title',
    loading: 'Loading...',
    user: 'Member Center',
    userLogin: 'Menber Login',
}
